import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { usersClient } from "@core/clients";
import { User } from "@core/types";

type TParams = {
  options?: UseQueryOptions<User, any, User, any>;
  userId?: string;
};

const useGetProfileQuery = ({ userId, options }: TParams = {}): UseQueryResult<User, any> => {
  return useQuery(
    ["get-profile", userId],
    async () => {
      const data = await usersClient.getProfile(userId ?? "");

      return data;
    },
    {
      ...options,
    }
  );
};

export default useGetProfileQuery;
